






















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetHospitals } from "@/request/hdr";
@Component({})
export default class IdrGerenxinxi extends Vue {
  @Prop()
  private message: any;
  private hospitals: any[] = [];
  private get ifCompose() {
    return this.$store.state.idrIfCompose;
  }
  private fetchHospitals() {
    GetHospitals(this).then((data: any) => {
      this.hospitals = data;
    });
  }
  private mounted() {
    this.fetchHospitals();
  }
}
